// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".visible-icon[data-v-19ca4c3e] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #6a6b6a;\n}\n.visible-icon[data-v-19ca4c3e]:hover {\n  background-color: #f2f2f2;\n  color: #151515;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
